import shortcut, { PRIMARY } from '@App/Vendor/Shortcut.js'
import { abrirModalHtml } from './Modal'

export function shortcuts() {
    return [
        // Ctrl+E para habilitar edição de widgets.
        shortcut('e', PRIMARY, function(event) {
            event.preventDefault()
            this.$store.commit('toggleModoEdiçãoParaWidgets')
        }),

        // Ctrl+F para abrir a pesquisa global.
        shortcut('k', PRIMARY, function(event) {
            event.preventDefault()
            abrirModalHtml(`<alo-pesquisa-global></alo-pesquisa-global>`, {
                layout: 'central',
            })
        }),
    ]
}
